import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { useEffect } from 'react';

export function AuthDebugger() {
  // Only show in development mode with explicit debug flag
  if (process.env.NODE_ENV !== 'development' || !import.meta.env.VITE_SHOW_AUTH_DEBUG) {
    return null;
  }

  const { user: authUser, firebaseUser, loading: authLoading, isInitialized } = useSupabaseAuth();
  const { user: rbacUser, isLoading: rbacLoading } = useSupabaseAuth();

  // Log debug info only occasionally to avoid spam
  useEffect(() => {
    const interval = setInterval(() => {
      console.log('🐛 AuthDebugger: Current state:', {
        authUser: authUser ? `${authUser.email} (${authUser.role})` : null,
        firebaseUser: firebaseUser ? firebaseUser.email : null,
        rbacUser: rbacUser ? `${rbacUser.email} (${rbacUser.role})` : null,
        authLoading,
        rbacLoading,
        isInitialized
      });
    }, 5000); // Log every 5 seconds instead of every render

    return () => clearInterval(interval);
  }, [authUser, firebaseUser, rbacUser, authLoading, rbacLoading, isInitialized]);
  return (
    <div style={{
      position: 'fixed',
      top: 10,
      right: 10,
      backgroundColor: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <div><strong>Auth Debug Info:</strong></div>
      <div>Auth User: {authUser ? `${authUser.email} (${authUser.role})` : 'None'}</div>
      <div>Firebase User: {firebaseUser ? firebaseUser.email : 'None'}</div>
      <div>RBAC User: {rbacUser ? `${rbacUser.email} (${rbacUser.role})` : 'None'}</div>
      <div>Auth Loading: {authLoading ? 'Yes' : 'No'}</div>
      <div>RBAC Loading: {rbacLoading ? 'Yes' : 'No'}</div>
      <div>Initialized: {isInitialized ? 'Yes' : 'No'}</div>
    </div>
  );
}
